module.exports = __webpack_public_path__ + "img/answer-call-mobile.c7002c38.png";